import React, { useEffect } from "react";
import "./AgentCard.css";
import column from "../../Images/Vector (9).png";
import grid from "../../Images/Group 1171279337.png";
import grid2 from "../../Images/Group 1171279337 (1).png";
import dropdown from "../../Images/Vector (8).png";
import { useState } from "react";



import PropertyTable from "../PropertyList/PropertyTable.jsx";
import PropertyGrid from "../PropertyList/PropertyGrid.jsx";
import PropertyColumn from "../PropertyList/PropertyColumn.jsx";
import Header from "../../Layout/Header.jsx";
import image from "../../Images/Rectangle 20 (1).png";
import whatsapp from "../../Images/Group 534.png";
import arrow2 from "../../Images/Vector (11).png";
import heart from "../../Images/Vector (10).png";
import redHeart from "../../Images/red-heart.png";
import plus from "../../Images/Vector@2x.png";
import HomeService from "../../Services/HomeService.js";
import { useNavigate } from "react-router-dom";
import Sidebar from "../../Layout/Sidebar.jsx";
import profes from "../../Images/profes.png";
import { useDispatch, useSelector } from "react-redux";
// import { getUser } from "../../Stores/Slices/AuthSlice.js";


const CommunityList = () => {
  const [isPremium, setIsPremium] = useState(true);
  const [progress, setProgress] = useState(0);
  const [toggle, settoggle] = useState(1);
  const [index, SetIndex] = useState();
  const [userId, setUserId] = useState("");
  const [allAdvertisement, setAllAdvertisement] = useState([]);
  const [loading, setLoading] = useState(true);

  // const { user } = useSelector((state) => state?.auth);

  const navigate = useNavigate();
  const handleInputChange = (event) => {
    const value = event.target.value;
    setProgress(value);
  };

  const handleNavigateDealer = (dealerDetails) => {
    navigate("/community-details", { state: { dealerDetails } });
  };

  useEffect(() => {
    const fetchLoginProfile = async () => {
      const response = await HomeService.getLoginProfile();
      // console.log("this is login profile response", response);
      if (!response.status) {
        navigate("/profile");
      }
      if (response?.status) {
        setUserId(response?.data?._id);
      }
    };
    fetchLoginProfile();
  }, [userId]);

  const fetchAllAdvertisement = async () => {
    const loggedInUserId = localStorage.getItem("loggedInUserId");
    try {
      // const res = await HomeService.getAllAdvertisement();

      const res = await HomeService.getUsers();
      console.log("XCV47", res.data);

      if (res?.status) {
        // setAllAdvertisement(
        //   res.data.sort(
        //     (d1, d2) => new Date(d1.createdOn) - new Date(d2.createdOn),
        //   ),
        // );
        // console.log("user", userId);
        let arr = [];
        const selfProfile = res?.data?.find(
          (item) => item?._id === loggedInUserId,
        );
        console.log("hello", loggedInUserId);
        arr.push(selfProfile);
        const filteredProfiles = res?.data?.filter(
          (item) =>
            (item?.clientsInHandCount > 0 || item?.propertiesInHandCount > 0) &&
            item?._id !== loggedInUserId,
        );
        arr.push(...filteredProfiles);

        setAllAdvertisement(arr);
      }
    } catch (error) {
      console.log("Error fetching users data", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);
  useEffect(() => {
    fetchAllAdvertisement();
    // console.log("all advertisement data", allAdvertisement);
  }, []);

  const [isFav, setIsFav] = useState(false);
  console.log("add", allAdvertisement);

  return (
    <>
      <>
        <Header />
        <Sidebar />
        <div
          className="uni_wrapper bg"
          // style={{
          //   display: 'flex',
          //   justifyContent: 'center',

          // }}
        >
          <div
            className="uni_container5"
            style={{
              padding: "20px",
            }}
            // style={{
            //   width: '100%',
            //   maxWidth: '80%',
            //   minWidth: '80%'
            // }}
          >
            <div
              className="property_grid_div5"
              style={{
                width: "100%",
                maxWidth: "80%",
                minWidth: "80%",
              }}
            >
              {/* new card design */}
              {/* <div className="agent-card-wrapper ">
                     <div className="agent-card premium-card-st">
                    
                    <div className="agent-image">
                      <img src={profes} alt="Michael Sterling" />

                      <div className="premium-badge">
                        <i className="fas fa-star" />
                        Premium
                      </div>

                      <div className="mobile-overlay">
                        <h3>Michael Sterling </h3>


                        <p>Sterling Estates & Partners</p>
                      </div>
                    </div>

                    
                    <div className="agent-content">
                      <div className="building-watermark">
                        <i className="fas fa-building"></i>
                      </div>
                      <div className="agent-header">
                        <div>
                          <h3 className="agent-name">
                            Michael Sterling
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="premium-icon" aria-hidden="true" data-testid="icon-verified"><path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"></path><path d="m9 12 2 2 4-4"></path></svg>

                          </h3>
                          <p className="agent-company">
                            Sterling Estates & Partners
                          </p>
                        </div>

                        <div className="icon-actions">
                          <button className="icon-btn">
                            <i className="fas fa-phone" />
                          </button>
                          <button className="icon-btn">
                            <i className="fas fa-envelope" />
                          </button>
                        </div>
                      </div>

                      <div className="info-grid-cm">
                        <div>
                          <div className="info-label">
                            <i className="fas fa-briefcase" />
                            Business Field
                          </div>
                          <div className="info-value">
                            Commercial & Luxury Residential
                          </div>
                        </div>

                        <div>
                          <div className="info-label">
                            <i className="fas fa-star" />
                            Experience
                          </div>
                          <div className="info-value">15 Years</div>
                        </div>

                        <div className="full-width">
                          <div className="info-label">
                            <i className="fas fa-map-marker-alt" />
                            Major Localities
                          </div>
                          <div className="localities">
                            <span>Downtown</span>
                            <span>Financial District</span>
                            <span>West End</span>
                            <span>Harbor View</span>
                          </div>
                        </div>
                      </div>

                      <div className="mobile-cta">
                        <button>Contact Agent</button>
                      </div>
                    </div>

                  <div className="accent-bar" />
               </div>
                </div> */}
              {loading ? (
                <div className="loader-wrapper">
                  <div className="loader"></div>
                </div>
              ) : (
                allAdvertisement?.map((e, i) => {
                  return (
                    <>
                      <div
                        className="agent-card-wrapper"
                        key={i}
                        onClick={() => {
                          handleNavigateDealer(e);
                        }}
                      >
                        <div className="agent-card">
                          {/* Image section */}
                          <div className="agent-image">
                            <img src={e?.image} alt="Profile Img" />
                            {userId === e?._id && (
                              <div className="premium-badge">
                                <i className="fas fa-star" />
                                Self Profile
                              </div>
                            )}

                            <div className="mobile-overlay">
                              <h3>Michael Sterling</h3>
                              <p>Sterling Estates & Partners</p>
                            </div>
                          </div>

                          {/* Content */}
                          <div className="agent-content">
                            <div className="building-watermark">
                              <i className="fas fa-building"></i>
                            </div>
                            <div className="agent-header">
                              <div>
                                <h3 className="agent-name">
                                  {e?.fullName}
                                  <i className="fas fa-badge-check verified-icon" />
                                </h3>
                                <p className="agent-company">
                                  {e?.companyName}
                                </p>
                              </div>

                              {/* <div className="icon-actions">
                              <button
                                onClick={() =>
                                  e?.mobileNo &&
                                  (window.location.href = `tel:${e.mobileNo}`)
                                }
                                className="icon-btn"
                              >
                                <i className="fas fa-phone" />
                              </button>
                              <button
                                onClick={() =>
                                  e?.email &&
                                  (window.location.href = `mailto:${e.email}`)
                                }
                                className="icon-btn"
                              >
                                <i className="fas fa-envelope" />
                              </button>
                            </div> */}
                            </div>

                            <div className="info-grid-cm">
                              <div>
                                <div className="info-label">
                                  <i className="fas fa-briefcase" />
                                  Business Field
                                </div>
                                <div className="info-value">
                                  {e?.businessField}
                                </div>
                              </div>

                              <div>
                                <div className="info-label">
                                  <i className="fas fa-star" />
                                  Experience
                                </div>
                                <div className="info-value">
                                  {e?.workExpYear}
                                </div>
                              </div>

                              <div className="full-width">
                                <div className="info-label">
                                  <i className="fas fa-map-marker-alt" />
                                  Major Localities
                                </div>
                                <div className="localities">
                                  {e?.majorLocality
                                    ?.split(",")
                                    ?.map((item, index) => (
                                      <span key={index}>{item}</span>
                                    ))}
                                  {/* <span>Downtown</span>
                            <span>Financial District</span>
                            <span>West End</span>
                            <span>Harbor View</span> */}
                                </div>
                              </div>
                            </div>

                            <div className="mobile-cta">
                              <button>Contact Agent</button>
                            </div>
                          </div>

                          <div className="accent-bar" />
                        </div>
                      </div>
                      {0 === 1 && (
                        <div
                          className="property_grid_two property_grid_new_class"
                          key={i}
                          onClick={() => {
                            handleNavigateDealer(e);
                          }}
                        >
                          <div className="propety_grid_img new_property_grid_img">
                            <img
                              className="propety_grid_img_display  new_propety_grid_img_display"
                              src={e?.image}
                            />
                            {e?.isFavorite && (
                              <div className="heart_div_2">
                                <img src={redHeart}></img>
                              </div>
                            )}

                            {/* <div className="heart_div_2">
                          <img src={isFav ? redHeart : heart}></img>
                        </div> */}
                          </div>
                          <div className="property_grid_data new_property_grid_data d-flex justify-content-between align-items-center flex-column">
                            <div className="property_grid_content">
                              <div className="property_data property_data_new_class">
                                {/* <div className="property_para_div">
                              <p className="property_data_para">
                                Email:
                              </p>
                              <p className="property_data_para2">
                                {e?._id} {e?.email}
                              </p>
                            </div> */}

                                <div className="property_para_div">
                                  <p className="property_data_para">
                                    Business Field:
                                  </p>
                                  <p className="property_data_para2">
                                    {e?.businessField}
                                    {/* {e?.businessField
                                  ?.map((field) => field.name)
                                  .join(", ")} */}
                                  </p>
                                </div>

                                <div className="property_para_div">
                                  <p className="property_data_para">
                                    Major Locality:
                                  </p>
                                  <p className="property_data_para2">
                                    {e?.majorLocality}
                                  </p>
                                </div>

                                <div className="property_para_div">
                                  <p className="property_data_para">
                                    Working Experience:
                                  </p>
                                  <p className="property_data_para2">
                                    {e?.workExpYear}
                                  </p>
                                </div>
                              </div>
                            </div>

                            {userId === e?.userId ? (
                              <div className="remark_button_wrapper_div">
                                <div className="submit_btn_icon_wrapper new_submit_btn_icon_wrapper">
                                  <button
                                    onClick={() => {
                                      handleNavigateDealer(e);
                                    }}
                                  >
                                    Fill Requirement
                                  </button>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                          {/* <div className="plus_div_icon">
                        <img src={plus}></img>
                      </div> */}
                        </div>
                      )}
                    </>
                  );
                })
              )}
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default CommunityList;
